import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';

export interface AddCumulativeTimeState {
    views: { [page: number]: number };
}

export default select<AddCumulativeTimeState>({
    views: () => store.views,
})(
    action('incrementViews')(function incrementViews(page: number, state?: AddCumulativeTimeState) {
        if (!(page in Object.keys(state.views))) {
            state.views[page] = 0;
        }

        state.views[page]++;
    })
);
